import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close--sprite",
  "use": "close--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"close--sprite\">\n  <path stroke=\"#565d60\" stroke-width=\".4\" d=\"M17 .425L16.49 0 8.5 7.99.425 0 0 .425 7.99 8.5 0 16.49l.425.51L8.5 8.925 16.49 17l.51-.51L8.925 8.5z\" transform=\"translate(7 8)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol